import { useState } from 'react';

import { useFlags } from 'launchdarkly-react-client-sdk';

import useDownloadQuery from 'hooks/useDownloadQuery/useDownloadQuery';
import { CuredApiPaths, DownloadQueryKeys, ApiMethods } from 'models/enums';
import { FiltersForApiState } from 'pages/InsightsPage/dashboards/filtering/types';

type Props = {
    queryKey: DownloadQueryKeys;
    path: CuredApiPaths;
    requestMethod: ApiMethods;
    csvFilenames: string[];
    filtersForApi: FiltersForApiState;
};

const useDashboardDownload = ({ queryKey, path, requestMethod, csvFilenames, filtersForApi }: Props) => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const { insightsDashboardSelectiveDownload } = useFlags();

    const { downloadFile, isDownloading, currentFilename, isSuccess, error, resetDownloadState } = useDownloadQuery(
        queryKey,
        path,
        requestMethod
    );

    const handleDownloadClick = () => {
        if (insightsDashboardSelectiveDownload) {
            setIsDialogOpen(true);
        } else {
            downloadFile({ filtersForApi });
        }
    };

    const handleDownloadAll = () => {
        downloadFile({ filtersForApi });
    };

    const handleDownloadFile = (filename: string) => {
        downloadFile({ filtersForApi, filename });
    };

    const handleDialogClose = () => {
        if (!isDownloading) setIsDialogOpen(false);
    };

    return {
        handleDownloadClick,
        isDialogOpen,
        onDialogClose: handleDialogClose,
        onDownloadAll: handleDownloadAll,
        onDownloadFile: handleDownloadFile,
        isDownloading,
        currentFilename,
        isSuccess,
        error,
        resetDownloadState,
        csvFilenames,
    };
};

export default useDashboardDownload;
